/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useRef, useState } from "react";

// react-router-dom components
import { Link, useLocation, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-in-cover.jpeg";
import { Auth } from "aws-amplify";
import validator from 'validator'
import { findUser, findUserForgetPassword, handleAuthErrorCognitoMessages } from "utils/helpers";
import { Box, ButtonGroup, Modal, Typography } from "@mui/material";
import Loader from "components/Loader";
import { useAppContext } from "context/app-context";
import { finalizeSignUp, getUniloginUri, loginWithUnilogin } from "services/user-services";
import { createSubscription, deletePendingSubscription, getSubscriptionSession, prepareSubscription, validateCoupon } from "services/reepay-services";
import { PricePlan } from "types";
// import uniLoginSVG from "assets/images/unilogin.svg";
import qs from 'query-string';
import { useUniLoginReply } from "layouts/authentication/complete";
import md5 from "md5";


declare const Reepay: any

let forceChangePassword: any | undefined = undefined
let notConfirmed: boolean | undefined = undefined
let subIdValue: string | undefined = undefined
let nameValue: string | undefined = undefined
let roleValue: string | undefined = undefined
let userValue: any | undefined = undefined
let emailValue: string | undefined = undefined
let passwordValue: string | undefined = undefined
function Cover(): JSX.Element {
  const { search } = useLocation()
  const { uniLoginAuthenticated } = qs.parse(search)

  const uniLoginReply = useUniLoginReply()

  useEffect(() => {
    if (uniLoginReply && uniLoginAuthenticated && uniLoginAuthenticated === 'true') {
      (async () => {
        setIsLoading(true)
        let user
        try {
          const response = await loginWithUnilogin({
            uniLoginUsername: uniLoginReply?.user,
            uniLoginAuth: uniLoginReply?.auth,
            uniLoginTimestamp: uniLoginReply?.timestamp
          })
          user = await Auth.signIn(response, md5(uniLoginReply?.user))
          if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            setResetPassword(true)
            forceChangePassword = user
          }

          setSubId(user.userSub)

          if (user) {
            navigate('/cards/generator')
          }

        } catch (error) {

        }


      })()
    }
  }, [uniLoginAuthenticated, uniLoginReply])

  const { setUser, setUserToken, handleMessage } = useAppContext()
  const [email, setEmail] = useState<string>(emailValue ?? '')
  const [password, setPassword] = useState<string>(passwordValue ?? '')
  const navigate = useNavigate()
  const [rememberMe, setRememberMe] = useState<boolean>(true);

  const [open, setOpen] = useState(forceChangePassword ?? false)
  const [openConfirmCode, setOpenConfirmCode] = useState(notConfirmed ?? false)
  const [resetEmail, setResetEmail] = useState<string>('')
  const [sentEmail, setSentEmail] = useState(forceChangePassword ?? false)
  const [username, setUsername] = useState<string>('')
  const [confirmationCode, setConfirmationCode] = useState<string>('')
  const [newPassword, setNewPassword] = useState<string>('')
  const [confirmNewPassword, setConfirmNewPassword] = useState<string>('')
  const [sessionId, setSessionId] = useState<string>('')
  const [subscriptionId, setSubscriptionId] = useState<string>()
  const [subId, setSubId] = useState<string>(subIdValue ?? '')
  const [name, setName] = useState<string>(nameValue ?? '')
  const [role, setRole] = useState<string>(roleValue ?? 'TEACHER')
  const [coupon, setCoupon] = useState('')
  const [pricePlan] = useState<PricePlan>('1year')

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [isLoading, setIsLoading] = useState(false)
  const [resetPassword, setResetPassword] = useState(forceChangePassword)
  const [authenticationWay, setAuthenticationWay] = useState('')



  const rpModalRef = useRef(null)

  useEffect(() => {
    if (userValue) {
      setUser(userValue)
    }
  }, [userValue])


  useEffect(() => {
    if (sessionId) {
      rpModalRef.current = new Reepay.WindowSubscription(sessionId)
      addReepayEventHandlers()
    }
  }, [sessionId])
  const handleSuccessPayment = async () => {
    await Auth.signOut()
  }

  const handleErrorPayment = () => {
  }

  const handleCancelPayment = async () => {
    if (subscriptionId) {
      setSubscriptionId(undefined)

      try {
        await deletePendingSubscription(subscriptionId)
      } catch (error: any) {
        if (error.status !== 404) {
          throw error
        } else {
          return
        }
      }

      await Auth.signOut()
    }
  }

  const handleClosePayment = async () => {
    await handleCancelPayment()
  }


  const addReepayEventHandlers = () => {
    if (!rpModalRef.current) {
      return
    }

    rpModalRef.current.addEventHandler(Reepay.Event.Accept, handleSuccessPayment)
    rpModalRef.current.addEventHandler(Reepay.Event.Error, handleErrorPayment)
    rpModalRef.current.addEventHandler(Reepay.Event.Cancel, handleCancelPayment)
    rpModalRef.current.addEventHandler(Reepay.Event.Close, handleClosePayment)
  }

  const handleConfirmCode = async () => {
    try {
      setIsLoading(true)
      await Auth.confirmSignUp(email, confirmationCode)
      setOpen(!open)
      const token = await Auth.signIn(email, password)
      setUserToken(
        token
      )

      let reepayResult
      if (coupon) {
        const v = await validateCoupon(coupon)
        if (!v.isValid) {
          throw Error('Kuponen er ikke gyldig.')
        }
        reepayResult = await createSubscription(token.attributes.sub, email,
          name, pricePlan, [coupon])

      } else {
        reepayResult = await prepareSubscription(token.attributes.sub, email,
          name, pricePlan, [])
        const subscriptionSessionId = await getSubscriptionSession(reepayResult.handle)
        if (subscriptionSessionId) {
          setSessionId(subscriptionSessionId.id)
        }
      }
      notConfirmed = undefined
      setUser(
        await finalizeSignUp(subId, { name, email, role, subscriptionId: reepayResult.handle })
      )
      navigate('/cards/generator')
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error.message, 'error')
    } finally {
      setIsLoading(false)
    }
  }

  const handleResendVerificationCode = async () => {
    try {
      await Auth.resendSignUp(email)
      handleMessage('Ny bekræftelseskode er sendt til din email', 'success')
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error.message, 'error')
    }
  }

  const handleSignIn = async () => {
    setIsLoading(true)
    let user
    try {
      // if (authenticationWay === 'email'){
      if (!validator.isEmail(email)) {
        handleMessage('Brug din registrerede e-mail', 'error')
        setIsLoading(false)
        return
      }
      user = await Auth.signIn(email, password)
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        setResetPassword(true)
        forceChangePassword = user
      }
      setSubId(user.userSub)
      if (user) {
        navigate('/cards/generator')
      }
      // } else {
      //   const { clientUri } = await getUniloginUri(`${window.location.href}?uniLoginAuthenticated=true`)
      //   window.location.href = clientUri
      // }
    } catch (error) {
      //@ts-ignore
      handleMessage(handleAuthErrorCognitoMessages(error?.response?.data?.message || error.code), 'error')
      setIsLoading(false)
      //@ts-ignore
      if (error.code === 'UserNotConfirmedException') {
        notConfirmed = true
        const data = await findUser(email)
        subIdValue = data.Users[0].Attributes.find((a: any) => a.Name === 'sub').Value
        roleValue = data.Users[0].Attributes.find((a: any) => a.Name === 'custom:role').Value
        nameValue = data.Users[0].Attributes.find((a: any) => a.Name === 'name').Value
        emailValue = data.Users[0].Attributes.find((a: any) => a.Name === 'email').Value
        passwordValue = password

        if (email && password) {
          navigate({
            pathname: '/bekraeftet'
          },
            {
              state: {
                email, password,
              }
            }
          )
        }
        //@ts-ignore
      } else if (error.code === 'NotAuthorizedException') {
        //@ts-ignore
        //@ts-ignore
        // handleMessage(error?.response?.data?.message || error.message, 'error')
      } else {
        throw error
      }
    }
  }

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };


  const submitResetPassword = async () => {
    setSentEmail(!sentEmail)
    const data = await findUserForgetPassword(resetEmail)
    const [user] = data.Users
    setUsername(user.Username)
    await Auth.forgotPassword(user.Username)
  }

  const submitNewPassword = async () => {
    if (newPassword !== confirmNewPassword) {
      handleMessage('Adgangskoderne er ikke ens', 'error')
      return
    }
    try {
      if (forceChangePassword) {
        await Auth.completeNewPassword(forceChangePassword, newPassword)
      } else {
        await Auth.forgotPasswordSubmit(username, confirmationCode, newPassword)
      }
      handleMessage('Du har ændret din adgangskode', 'success')
      setSentEmail(false)
      setOpen(false)
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }
  }

  return (
    <>
      {isLoading ? <Loader /> :
        <CoverLayout image={bgImage}>
          <Modal
            open={openConfirmCode}
            onClose={() => setOpenConfirmCode(!openConfirmCode)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Indsæt bekræftelseskode
              </Typography>
              <MDBox pr={1} mt={2.5}>
                <MDInput fullWidth value={confirmationCode} onChange={(e: any) => setConfirmationCode(e.target.value)} label="Bekræftelseskode" />
              </MDBox>
              <MDBox pr={1} mt={2.5} justifyContent='space-between' display='flex'>
                <MDButton onClick={handleConfirmCode} color='success' >
                  Tilføj
                </MDButton>
                <MDButton onClick={handleResendVerificationCode} color='info' >
                  Send igen
                </MDButton>
              </MDBox>
            </Box>
          </Modal>
          <Card>
            <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="success"
              mx={2}
              mt={-8}
              p={3}
              mb={1}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                Log ind
              </MDTypography>
              <MDTypography display="block" variant="button" color="white" my={1}>
                Skriv din email og kodeord for at logge ind
              </MDTypography>
            </MDBox>
            <MDBox pt={4} pb={3} px={3}>
              {/* <div style={{ textAlign: 'center' }}>
                <ButtonGroup variant="contained" aria-label="outlined primary button group">
                  <MDButton onClick={() => setAuthenticationWay('email')} color={authenticationWay === 'email' ? "secondary" : 'light'}>E-mail</MDButton>
                  <MDButton onClick={() => setAuthenticationWay('unilogin')} color={authenticationWay === 'unilogin' ? "secondary" : 'light'}>
                    <img
                      style={{ filter: 'drop-shadow(0 0 2px rgb(255 255 255 / 1))' }}
                      width={80} src={uniLoginSVG} alt="unilogin" /></MDButton>
                </ButtonGroup>
              </div> */}
              <MDBox component="form" role="form">

                {/* {authenticationWay === 'email' && ( */}
                <>
                  <MDBox mb={2}>
                    <MDInput
                      type="email"
                      label="Email"
                      variant="standard"
                      value={email}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                      fullWidth
                      placeholder="john@example.com"
                      InputLabelProps={{ shrink: true }}
                    />
                  </MDBox>
                  <MDBox mb={2}>
                    <MDInput
                      type="password"
                      label="Kodeord"
                      variant="standard"
                      value={password}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                      fullWidth
                      placeholder="************"
                      InputLabelProps={{ shrink: true }}
                    />
                  </MDBox>
                  <MDBox display="flex" alignItems="center" ml={-1}>
                    <Switch checked={rememberMe} onChange={handleSetRememberMe} />
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="text"
                      onClick={handleSetRememberMe}
                      sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                    >
                      &nbsp;&nbsp;Husk mig
                    </MDTypography>
                  </MDBox>
                  <MDBox mt={4} mb={1}>
                    <MDButton disabled={isLoading} onClick={handleSignIn} variant="gradient" color="info" fullWidth>
                      log ind
                    </MDButton>
                  </MDBox>
                </>
                {/* )}
                {authenticationWay === 'unilogin' && (
                  <MDBox mt={4} mb={1}>
                    <MDButton disabled={isLoading} onClick={handleSignIn} variant="gradient" color="info" fullWidth>
                      log ind
                    </MDButton>
                  </MDBox>
                )} */}

                <MDBox mt={3} mb={0} textAlign="center">
                  <MDTypography variant="button" color="text">
                    Ingen konto?{" "}
                    <MDTypography
                      component={Link}
                      to="/authentication/sign-up"
                      variant="button"
                      color="info"
                      fontWeight="medium"
                      textGradient
                    >
                      Opret dig
                    </MDTypography>
                  </MDTypography>
                </MDBox>
                <MDBox mt={0} mb={0} textAlign="center">
                  <MDTypography variant="button" color="text">
                    Geeksters bruger?{" "}
                    <MDTypography
                      component={Link}
                      to="/authentication/geekster-sign-up"
                      variant="button"
                      color="info"
                      fontWeight="medium"
                      textGradient
                    >
                      Klik her
                    </MDTypography>
                  </MDTypography>
                </MDBox>
                <MDBox mt={0} mb={1} textAlign="center">
                  <MDTypography variant="button" color="text">
                    Glemt kodeord?{" "}
                    <MDTypography
                      onClick={() => setOpen(!open)}
                      style={{ cursor: 'pointer' }}
                      variant="button"
                      color="info"
                      fontWeight="medium"
                      textGradient
                    >
                      Nulstil kodeord
                    </MDTypography>
                  </MDTypography>
                </MDBox>
                <Modal
                  open={open}
                  onClose={() => {
                    setOpen(!open)
                  }}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDBox sx={style}>
                    {sentEmail ? <>
                      <Typography id="modal-modal-title" variant="h6" component="h2">
                        Fill the requested information down bellow
                      </Typography>
                      <MDBox mx='auto' mt={2.5}>
                        {!resetPassword && <MDInput
                          fullWidth
                          label="Confirmation Code"
                          value={confirmationCode}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmationCode(e.target.value)}
                        />}
                      </MDBox>
                      <MDBox mt={1}>
                        <MDInput
                          fullWidth
                          type='password'
                          label="New password"
                          value={newPassword}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewPassword(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mt={1}>
                        <MDInput
                          fullWidth
                          type='password'
                          label="Confirm Password"
                          value={confirmNewPassword}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmNewPassword(e.target.value)}
                        />
                      </MDBox>
                      <MDBox display='flex' justifyContent='center' pr={1} mt={2.5}>
                        <MDButton onClick={submitNewPassword} color='success' >
                          Submit
                        </MDButton>
                      </MDBox>
                    </> : <>
                      <Typography id="modal-modal-title" variant="h6" component="h2">
                        Write your e-mail down bellow
                      </Typography>
                      <MDBox pr={1} mt={2.5}>
                        <MDInput
                          fullWidth
                          value={resetEmail}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setResetEmail(e.target.value)}
                        />
                      </MDBox>
                      <MDBox display='flex' justifyContent='center' pr={1} mt={2.5}>
                        <MDButton onClick={submitResetPassword} color='success' >
                          Submit
                        </MDButton>
                      </MDBox>
                    </>}
                  </MDBox>
                </Modal>
              </MDBox>
            </MDBox>
          </Card>
        </CoverLayout >
      }</>
  );
}

export default Cover;
